import React from 'react'
import "./HomeHero.css"
import Header from '../Header/Header'
import { useNavigate } from 'react-router-dom'


function HomeHero() {
  const navigate = useNavigate()
  return (
    <>
    <Header/>
    <div className='HomeHero-container standard-padding-space d-flex'>
        <div className='container my-auto'>
            <div className='content-container text-start my-auto'>
                <h3 className='hero-section-heading color-dark' style={{textTransform:"none"}}>Dare to be you,<br></br> Tell it boldly.</h3>
                <p className='body-paragraph color-dark my-4'>Story-driven marketing for <br></br> professionals ready to lead <br></br> with clarity and confidence</p>
                <button className='genral-btn btn-dark mt-2' onClick={()=>{navigate("/contact")}}>Book a Discovery Call</button>
            </div>

        </div>
    </div>
    </>
  )
}

export default HomeHero